module.exports = __webpack_public_path__ + "static/media/ray-portrait.df6a81c1.svg";